export default class StudentsAPI {
  private services: any;

  constructor(services) {
    this.services = services;
  }

  public getCoursesSummary({ studentID }) {
    return this.services.baseAPI.get(
      `/students/courses?studentid=${studentID}`,
      false
    );
  }

  public requestNextCourse(id) {
    return this.services.plBaseAPI.get(
      `/content/courses/from_sf/${id}/request_start`
    );
  }

  public getLessonAllocations() {
    return this.services.plBaseAPI.get(`/content/lessons/current_allocations`);
  }

  public getLessonPerformance({ allocationID }) {
    return this.services.baseAPI.get(
      `/students/lesson_performance?allocationid=${allocationID}`,
      false
    );
  }
  public getRecommendedCourses() {
    return this.services.baseAPI.get(`/courses/recommended`, false);
  }
  public getTopBottomBehaviours() {
    return this.services.baseAPI.get(`/datacenter/behaviours_top_bottom`);
  }

  public getAllBehaviours() {
    return this.services.baseAPI.get(`datacenter/behaviours_all`);
  }

  public makePayment(item) {
    return this.services.baseAPI.post(
      `users/students/make_payment`,
      item,
      false
    );
  }

  public switchSubscriptionPackage(item) {
    return this.services.baseAPI.post(`users/students/switch_package`, item);
  }

  public cancelSubscription() {
    return this.services.baseAPI.post(`users/students/cancel_subscription`);
  }

  public rateLessonContent(item) {
    return this.services.baseAPI.post(
      `users/lessons/ratings/rate_lesson`,
      item
    );
  }

  public createLessonAttempt(id, item) {
    return this.services.plBaseAPI.post(
      `content/lessons/${id}/initialize_attempt`,
      item
    );
  }

  public rateLessonFeeling(item) {
    return this.services.baseAPI.post(
      `users/lessons/ratings/emotion_rate_lesson`,
      item
    );
  }

  public getPlexHomeStats() {
    return this.services.baseAPI.get(`users/assessments/plex_home_stats`);
  }

  public getCoursesSF(id) {
    return this.services.plBaseAPI.get(
      `content/search_filters/${id}/lessons/list`
    );
  }

  public getSearchFilterList() {
    return this.services.plBaseAPI.get(`search_filters/list`);
  }
  public getInteractionByUrl(path) {
    return this.services.baseAPI.get(path);
  }

  public getLessonScreen(id, screenNo) {
    return this.services.plBaseAPI.get(
      `content/lessons/${id}/screens/${screenNo}`
    );
  }

  public getLessonScreenList(id) {
    return this.services.plBaseAPI.get(`content/lessons/${id}/screens/list`);
  }

  public getUserNextLessonEta() {
    return this.services.plBaseAPI.get(`content/lessons/next_eta`);
  }

  public getLearnerAssessments(learnerId) {
    return this.services.baseAPI.get(
      `datacenter/school_student_assessments_breakdown?id=${learnerId}`
    );
  }

  public downloadLearnerReport(assessmentId, sid) {
    return this.services.plBaseAPI.get(
      `assessments/reports/${assessmentId}/single_learner_v2_report?sid=${sid}`
    );
  }
}



// WEBPACK FOOTER //
// ./src/services/API/v1/Students.ts